import type { UnitInfoDataInterface } from 'store/unitInfoData/types';
import { get } from '../apiClient';

const VERSION = 'v1';
const BASE_PATH = `simulation/${VERSION}`;

export async function getUnitInfoData() {
  return get<UnitInfoDataInterface>(`${BASE_PATH}/unitInfoData`);
}
